import { render, staticRenderFns } from "./ReportDetailView.vue?vue&type=template&id=44424560&scoped=true&"
import script from "./ReportDetailView.vue?vue&type=script&lang=js&"
export * from "./ReportDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailView.vue?vue&type=style&index=0&id=44424560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44424560",
  null
  
)

export default component.exports